<template>
  <Teleport :to="'#' + portal">
    <div>
      <transition name="fade" appear>
        <div
          v-if="_active"
          key="lightbox-overlay"
          class="fixed inset-0 w-full h-full z-80000 pointer-events-none"
        >
          <div
            class="absolute inset-0 w-full h-full bg-gray-900 opacity-75 pointer-events-auto"
            @click="close()"
          />

          <o-button
            class="pointer-events-auto float-right m-3"
            variant="dark"
            transparent
            icon="x"
            :icon-size="22"
            @click="close()"
          />

          <div class="flex items-center justify-center w-full h-full absolute inset-0">
            <slot item="current">
              <div class="rounded overflow-hidden max-h-90vh max-w-90vw">
                <img
                  v-show="!isLoading"
                  :src="current.url"
                  @load="loaded"
                >
                <div v-if="isLoading" class="min-w-140 min-h-100 bg-gray-800 flex items-center justify-center">
                  <o-loader />
                </div>
                <div class="bg-gray-900 text-white p-2">
                  <p v-if="current.title">
                    {{ current.title }}
                  </p>
                  <p v-if="current.created" class="text-sm">
                    {{ current.created }}
                  </p>
                </div>
              </div>
            </slot>
          </div>

          <div class="flex items-center justify-between h-full w-full inset-0 absolute p-2">
            <o-button class="pointer-events-auto py-6" variant="dark" icon="chevronLeft" :icon-size="18" @click="previous()" />
            <o-button class="pointer-events-auto py-6" variant="dark" icon="chevronRight" :icon-size="18" @click="next()" />
          </div>
        </div>
      </transition>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
interface Props {
  active: boolean
  index?: number
  items: any[]
  portal?: string
}

const props = withDefaults(defineProps<Props>(), {
  index: 1,
  portal: 'dialog-container',
})

const emit = defineEmits<{
  (e: 'update:active', value: boolean): void
  (e: 'update:index', value: number): void
}>()

const isLoading = ref(true)

const _active = computed({
  get() {
    return props.active
  },
  set(value: boolean) {
    emit('update:active', value)
  },
})

const _index = computed({
  get() {
    return props.index
  },
  set(value: number) {
    emit('update:index', value)
  },
})

const current = computed(() => {
  return props.items[props.index] || props.items[0]
})

watch(() => props.index, () => {
  isLoading.value = true
})

function next() {
  const index = _index.value + 1
  if (index > props.items.length - 1) {
    _index.value = 0
  } else {
    _index.value = index
  }
}

function previous() {
  const index = _index.value - 1
  if (index < 0) {
    _index.value = props.items.length - 1
  } else {
    _index.value = index
  }
}

function close() {
  _active.value = false
}

function loaded() {
  isLoading.value = false
}
</script>
